'use client'

import { CheckCircleIcon } from '@heroicons/react/24/solid'
import { cn } from '@admin/lib/utils'
import React from 'react'

import { Typography } from '@pw-tech/omni-ui'
import { useOTPLess } from '@/contexts/otpless.context'

const Steppers = ({
  activeInd,
  steps,
  handleUpdateInd,
}: {
  activeInd: number
  steps: { title: string }[]
  handleUpdateInd: (index: number) => void
}) => {
  const { shouldTriggerTruecaller } = useOTPLess()
  return (
  <div className="flex flex-row md:w-[360px] w-[220px] mx-auto">
      {steps.map((step, index) => (
        <React.Fragment key={index}>
          <div
            className="flex flex-col md:gap-[10px] gap-[6px] items-center"
            role='button'
            tabIndex={0}
            onClick={() => handleUpdateInd(index)}
          >
            {index < activeInd ? (
              <CheckCircleIcon className="w-6 h-6" color='#1b7938' />
            ) : (
              <Typography
                color='#fff'
                className={cn(
                  'w-6 h-6 p-2 rounded-full flex items-center justify-center',
                  activeInd === index ? 'bg-[#ff6d0a]' : 'bg-[#989DA5]'
                )}
              >
                {index + 1}
              </Typography>
            )}
            <Typography variant='regular' weight='semi-bold' color='#1b2124'>
              {step.title}
            </Typography>
          </div>
          {index !== steps.length - 1 && <div className="flex-1 border-t border-[#E5E7EB] h-0 relative top-4" />}
        </React.Fragment>
      ))}
    </div>
  )
}

export default Steppers
